<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> INSERÇÃO INDICADORES DE DESEMPENHO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-alert :type="typeAlert" v-if="messageAlert">
        <template v-slot:close>
          <v-icon @click="() => (messageAlert = '')"> mdi-close </v-icon>
        </template>
        {{ messageAlert }}
      </v-alert>
      <v-form
        ref="form"
        class="compact-form"
        v-model="valid"
        :lazy-validation="lazy"
      >
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="3" class="pt-5" v-if="false">
              Selecione o Período de Lançamento:</v-col
            >
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="3">
              <v-btn
                @click="loadCompanies"
                color="blue darken-3"
                small
                class="mt-1 white--text"
              >
                <v-icon left> mdi-plus </v-icon>
                Carregar Franqueados
              </v-btn>
            </v-col>
            <v-col cols="12" xs="6" md="5">
              <v-btn
                :disabled="companies.length == 0"
                @click="exportExcel()"
                color="grey darken-4"
                outlined
                small
                class="mt-1 float-right"
              >
                <v-icon color="green" left> mdi-file-excel-box </v-icon>
                Excel
              </v-btn>
              <v-btn
                :disabled="companies.length == 0"
                @click="exportPdf()"
                color="grey darken-4"
                outlined
                small
                class="mt-1 mr-1 float-right"
              >
                <v-icon color="red" left> mdi-file-pdf-box </v-icon>
                PDF
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card elevation="0">
                <v-toolbar
                  color="blue darken-4"
                  class="font-weight-bold"
                  dense
                  outlined
                  height="28"
                  dark
                  >Faturamento/Vendidos mês Anterior</v-toolbar
                >
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="400">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center text-no-wrap" width="50px">
                                Filial
                              </th>
                              <th class="text-left text-no-wrap" width="">
                                Franqueado
                              </th>
                              <th class="text-left text-no-wrap" width="120px">
                                Cidade/UF
                              </th>
                              <th class="text-left text-no-wrap" width="100px">
                                CNPJ
                              </th>
                              <th
                                class="text-left text-no-wrap"
                                style="min-width: 110px"
                                width="10%"
                              >
                                <v-tooltip bottom color="info">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">Pares</span>
                                  </template>
                                  <span
                                    >Informe aqui a quantidade de Pares vendidos
                                    no mês anterior</span
                                  >
                                </v-tooltip>
                              </th>
                              <th
                                class="text-left text-no-wrap"
                                style="min-width: 110px"
                                width="10%"
                              >
                                <v-tooltip bottom color="info">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on"
                                      >Acessórios</span
                                    >
                                  </template>
                                  <span
                                    >Informe aqui a quantidade de Acessórios
                                    vendidos no mês anterior</span
                                  >
                                </v-tooltip>
                              </th>
                              <th class="text-left text-no-wrap" width="10%">
                                <v-tooltip bottom color="info">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on"
                                      >Prod. Conserv.</span
                                    >
                                  </template>
                                  <span
                                    >Informe aqui a quantidade de Produtos de
                                    Conservação vendidos no mês anterior</span
                                  >
                                </v-tooltip>
                              </th>
                              <th class="text-left text-no-wrap" width="10%">
                                <v-tooltip bottom color="info">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on"
                                      >Estoque Pares</span
                                    >
                                  </template>
                                  <span
                                    >Informe aqui o Estoque Atual de Pares</span
                                  >
                                </v-tooltip>
                              </th>
                              <th class="text-left text-no-wrap" width="15%">
                                <v-tooltip bottom color="info">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on"
                                      >(R$) Faturamento</span
                                    >
                                  </template>
                                  <span
                                    >Informe aqui o Faturamento Total da sua
                                    loja no mês anterior</span
                                  >
                                </v-tooltip>
                              </th>
                              <th class="text-right text-no-wrap" width="5%">
                                (%) Nacional
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="company in companies"
                              :key="company.id"
                              :class="company.check ? 'yellow lighten-4' : ''"
                            >
                              <td class="text-center">{{ company.code }}</td>
                              <td>{{ company.name }}</td>
                              <td class="text-left">
                                {{ company.delivery_city }} -
                                {{ company.delivery_state }}
                              </td>
                              <td class="text-left">
                                {{ company.document }}
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  outlined
                                  dense
                                  class="fs-12"
                                  hide-details
                                  v-model="company.pairs"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  outlined
                                  dense
                                  class="fs-12"
                                  hide-details
                                  v-model="company.accessories"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  outlined
                                  dense
                                  class="fs-12"
                                  hide-details
                                  v-model="company.conservation_products"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  outlined
                                  dense
                                  class="fs-12"
                                  hide-details
                                  v-model="company.stock"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <!-- <v-text-field
                                  outlined
                                  dense
                                  hide-details
                                  value="0.00"
                                  class="fs-12"
                                  reverse
                                  v-model="company.billing"
                                ></v-text-field> -->
                                <v-text-field-money
                                  v-model="company.billing"
                                  label=""
                                  class="fs-12"
                                  v-bind:properties="{
                                    prefix: '',
                                    readonly: false,
                                    reverse: true,
                                    dense: true,
                                    hideDetails: true,
                                    outlined: true,
                                    clearable: false,
                                    placeholder: ' ',
                                    class: 'fs-12',
                                  }"
                                  v-bind:options="{
                                    locale: 'pt-BR',
                                    length: 11,
                                    precision: 2,
                                    empty: null,
                                  }"
                                />
                              </td>
                              <td class="text-right">
                                {{ getNationalPercent(company) }} %
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="companies.length > 0">
                            <tr>
                              <th></th>
                              <th></th>
                              <th></th>
                              <th></th>
                              <th class="text-center">
                                {{ getTotalSum("pairs") }}
                              </th>
                              <th class="text-center">
                                {{ getTotalSum("accessories") }}
                              </th>
                              <th class="text-center">
                                {{ getTotalSum("conservation_products") }}
                              </th>
                              <th class="text-center">
                                {{ getTotalSum("stock") }}
                              </th>
                              <th class="text-center">
                                {{ getTotalSum("billing") | currencyEuaToBr }}
                              </th>
                              <th></th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-col cols="12" class="pt-0">
                    <v-btn
                      color="green darken-3"
                      class="float-right white--text"
                      small
                      @click="validate"
                    >
                      <v-icon left> mdi-check </v-icon>
                      Gravar Lançamentos
                    </v-btn>
                  </v-col>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import AwesomeMask from "awesome-mask";

export default {
  components: {},
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    companies: [],
    loading: false,
    typeAlert: "success",
    messageAlert: "",
    successSave: false,
    lazy: false,
    valid: true,
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();

    this.initialize();
  },
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  methods: {
    async initialize() {},
    async loadCompanies() {
      this.messageAlert = "";
      // this.successSave = false;
      // this.loading = true;
      this.download = {
        link: "#",
        name: "",
      };
      this.linkDownload = false;
      this.companies = [];
      try {
        let response = await fetch(
          `${URL}performance-indicator?month=${this.month}&year=${this.year}`
        );
        let data = await response.json();
        this.companies = data
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((item) => ({
            ...item,
            pairs: item.pairs == 0 ? "" : item.pairs,
            accessories: item.accessories == 0 ? "" : item.accessories,
            conservation_products:
              item.conservation_products == 0 ? "" : item.conservation_products,
            stock: item.stock == 0 ? "" : item.stock,
            billing:
              item.billing == 0 ? "" : parseFloat(item.billing).toFixed(2),
          }));
        console.log(this.companies);
      } catch (error) {
        this.messageAlert =
          "Problema ao carregar as empresas e indicadores, tente novamente mais tarde";
        this.typeAlert = "error";
        this.companies = [];
      } finally {
        // this.loading = false;
      }
    },
    getCountCompaniesChecked() {
      return this.companies.filter((i) => i.check != false).length;
    },
    validate() {
      let data = this.companies.map((item) => ({
        company_id: item.id,
        id: item.indicator_id,
        month: this.month,
        year: this.year,
        pairs: parseInt(item.pairs),
        accessories: parseInt(item.accessories),
        conservation_products: parseInt(item.conservation_products),
        stock: parseInt(item.stock),
        billing: item.billing,
        national_percent: parseFloat(this.getNationalPercent(item)),
      }));
      console.log(data);
      if (data.length > 0) {
        this.post(data);
      } else {
        this.messageAlert =
          "Não foi possível salvar os indicadores, lista de empresas não localizada";
        this.typeAlert = "error";
      }
    },
    async post(data) {
      this.loading = true;
      // this.successSave = false;
      this.messageAlert = "";
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}performance-indicator`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (res) {
          let response = await res.json();
          console.log(response);
          // this.successSave = true;
          this.messageAlert = "Indicadores salvos com sucesso";
          this.typeAlert = "success";
        } else {
          throw new Error(res.message);
        }
      } catch (error) {
        this.messageAlert =
          "Problema ao salvar os indicadores, tente novamente mais tarde";
        this.typeAlert = "error";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getTotalSum(field) {
      let total = this.companies.reduce(
        (prev, curr) =>
          prev +
          (!isNaN(parseFloat(curr[field])) ? parseFloat(curr[field]) : 0),
        0
      );
      return field !== "billing" ? parseInt(total) : total.toFixed(2);
    },
    getNationalPercent(company) {
      if (company.billing === "" || parseFloat(company.billing) === 0.0) {
        return "0.00";
      }
      return parseFloat(
        (company.billing / this.getTotalSum("billing")) * 100
      ).toFixed(2);
    },
    currencyBrToEua(value) {
      return value.toString().replace(/\./gi, "").replace(/,/gi, ".");
    },
    async exportPdf() {
      this.download = {
        name: "",
        link: "#",
      };
      this.loading = true;
      this.linkDownload = false;
      let data = {};
      data.companies = this.companies.map((item) => ({
        ...item,
        pairs: parseInt(item.pairs),
        accessories: parseInt(item.accessories),
        conservation_products: parseInt(item.conservation_products),
        stock: parseInt(item.stock),
        billing: item.billing,
        national_percent: parseFloat(this.getNationalPercent(item)),
      }));
      data.month = this.month;
      data.year = this.year;

      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}performance-indicator/export/pdf`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        console.log(response);
        this.download.name = response.nome;
        this.download.link = `${URL}performance-indicator/download/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        this.messageAlert =
          "Problema ao gerar o PDF, tente novamente mais tarde";
        this.typeAlert = "error";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async exportExcel() {
      this.download = {
        name: "",
        link: "#",
      };
      this.loading = true;
      this.linkDownload = false;
      let data = {};
      data.companies = this.companies.map((item) => ({
        ...item,
        pairs: parseInt(item.pairs),
        accessories: parseInt(item.accessories),
        conservation_products: parseInt(item.conservation_products),
        stock: parseInt(item.stock),
        billing: item.billing,
        national_percent: parseFloat(this.getNationalPercent(item)),
      }));
      data.month = this.month;
      data.year = this.year;

      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}performance-indicator/export/excel`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        console.log(response);
        this.download.name = response.nome;
        this.download.link = `${URL}performance-indicator/download/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        this.messageAlert =
          "Problema ao gerar o EXCEL, tente novamente mais tarde";
        this.typeAlert = "error";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
#styled-input {
  height: 40px;
  font-size: 20pt;
}
.compact-form .fs-12 {
  transform: scale(0.8);
  transform-origin: left;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
